import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function Screen() {
  const [loading, setLoading] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState("");
  const [activeBox, setActiveBox] = useState(""); // <-- Highlight selected
  const navigate = useNavigate();

  const handleMatchClick = (matchName) => {
    setActiveBox(matchName); // highlight clicked box
    setLoading(true);
    setSelectedMatch(`Fetching data for ${matchName}...`);

    navigate(`/${matchName.toLowerCase().replace(" ", "-")}`);
  };

  // 🔥 A reusable function to create boxes
  const renderBox = (label, matchName, defaultColor, activeColor) => (
    <div className="col-md-3 col-sm-6 mb-4">
      <div
        className={`border text-white text-center p-4 d-flex justify-content-center align-items-center 
          ${activeBox === matchName ? activeColor : defaultColor}`}
        style={{
          fontSize: "18px",
          cursor: "pointer",
          borderRadius: "10px",
          height: "150px",
        }}
        onClick={() => handleMatchClick(matchName)}
      >
        {label}
      </div>
    </div>
  );

  return (
    <div className="d-flex vh-100">
      <main className="flex-grow-1 p-4" style={{ backgroundColor: "#f8f9fa" }}>
        <h1>Welcome Unit I</h1>
        <br />

        <div className="container mt-5">
          <div className="row">
            {renderBox("Flow", "FlowI", "bg-primary", "bg-success")}
            {renderBox("Crushing", "CrushingI", "bg-danger", "bg-warning")}
            {renderBox("Yard Summary", "DataScreenI", "bg-primary", "bg-success")}
            {renderBox(
              "Estimated Avg. Cost of Yard Balance",
              "EstimatedAGI",
              "bg-success",
              "bg-dark"
            )}
          </div>

          <div className="row">
            {renderBox("On Date To Date Avg. Cost", "AgAsI", "bg-info", "bg-primary")}
            {renderBox("Sugar In Process", "stockI", "bg-dark", "bg-secondary")}
            {renderBox("Lab Analysis", "labanaI", "bg-warning", "bg-danger")}
            {renderBox("Sugar Cost", "sugarcostI", "bg-secondary", "bg-info")}
          </div>

          <div className="row">
            {renderBox("SugarCane Analysis", "scAnalysisI", "bg-primary", "bg-success")}
            {renderBox(
              "Date Wise Registration",
              "elpregistrationdateI",
              "bg-success",
              "bg-dark"
            )}
            {renderBox(
              "On The Way",
              "elpregistrationwayI",
              "bg-danger",
              "bg-warning"
            )}
          </div>

          {/* Loading & Selected Message */}
          <div className="mt-4">
            {loading && <div className="alert alert-warning">Loading...</div>}
            {!loading && selectedMatch && (
              <div className="alert alert-info">{selectedMatch}</div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Screen;
